import { render, staticRenderFns } from "./nxMobilePicture.vue?vue&type=template&id=1c0a8303&scoped=true&"
import script from "./nxMobilePicture.vue?vue&type=script&lang=js&"
export * from "./nxMobilePicture.vue?vue&type=script&lang=js&"
import style0 from "./nxMobilePicture.vue?vue&type=style&index=0&id=1c0a8303&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0a8303",
  null
  
)

export default component.exports